import script from "./demo-requests-list.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-requests-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__